import { MantineProvider as Provider, createTheme, MantineThemeOverride } from '@mantine/core';
import { emotionTransform, MantineEmotionProvider } from '@mantine/emotion';
import { Notifications } from '@mantine/notifications';
import React from 'react';

import { COLORS } from '@/utils/colors';

export default function MantineProvider({ children }: { children: React.ReactNode }) {
  const theme = createTheme({
    primaryColor: 'dark',
    colors: {
      dark: [
        '#C1C2C5',
        '#A6A7AB',
        '#909296',
        '#5C5F66',
        '#373A40',
        '#2C2E33',
        '#25262B',
        '#1A1B1E',
        '#141517',
        '#101113',
      ],
      gray: [
        '#F8F9FA',
        '#F1F3F5',
        '#E9ECEF',
        '#DEE2E6',
        '#CED4DA',
        '#ADB5BD',
        '#868E96',
        '#495057',
        '#343A40',
        '#212529',
      ],
    },
    components: {
      Checkbox: {
        defaultProps: {
          color: COLORS.checkbox,
        },
        styles: {
          input: { cursor: 'pointer' },
          label: { cursor: 'pointer' },
        },
      },
      Loader: {
        defaultProps: {
          color: COLORS.primary,
        },
      },
      Paper: {
        styles: {
          root: {
            backgroundColor: COLORS.background,
          },
        },
      },
      Button: {
        defaultProps: {
          color: COLORS.primary,
        },
      },
      Text: {
        defaultProps: {
          color: COLORS.text,
          fw: '500',
        },
      },
      NavLink: {
        styles: {
          root: {
            borderRadius: 10,
            marginTop: 10,
            color: COLORS.primary,
            '&[data-active]': {
              backgroundColor: COLORS.activeNavlink,
            },
          },
          label: {
            color: COLORS.text,
          },
        },
      },
      Tabs: {
        styles: {
          list: {
            gap: 8,
            flexWrap: 'nowrap',
          },
          tab: {
            border: '1px solid transparent',
            borderBottom: 'none',
            borderRadius: '8px 8px 0 0',
            padding: '10px 16px',
            marginBottom: -1,
            backgroundColor: 'transparent',
            color: 'var(--mantine-color-gray-5)',
            '&[data-active]': {
              backgroundColor: 'var(--mantine-color-dark-6)',
              color: COLORS.text,
              border: `1px solid ${COLORS.primary}`,
              borderBottom: `1px solid var(--mantine-color-dark-6)`,
            },
            '&:hover:not([data-active])': {
              backgroundColor: 'rgba(68, 133, 207, 0.06)',
            },
          },
        },
      },
    },
  } as MantineThemeOverride);
  return (
    <Provider
      defaultColorScheme={'dark'}
      stylesTransform={emotionTransform}
      theme={theme}
      withGlobalClasses
    >
      <MantineEmotionProvider>
        <Notifications containerWidth={350} />
        {children}
      </MantineEmotionProvider>
    </Provider>
  );
}
